module.exports = __webpack_public_path__ + "static/favicon-196x196-b1fd6ae8b5154fac59cc1ca0955ea4c9.png";